import type React from "react";

// Fecha o modal só se mousedown E mouseup caíram no backdrop (cópia de
// apps/frontend/src/components/shared/backdrop.ts sem o DiscardPrompt).
export function backdropClose(onClose: () => void): Pick<React.HTMLAttributes<HTMLDivElement>, "onMouseDown" | "onMouseUp"> {
  return {
    onMouseDown: (e) => { e.currentTarget.dataset.armed = e.target === e.currentTarget ? "1" : ""; },
    onMouseUp: (e) => {
      const el = e.currentTarget;
      const hit = el.dataset.armed === "1" && e.target === el;
      el.dataset.armed = "";
      if (hit) onClose();
    },
  };
}
